import * as Actions from './SessionSurveyActions';
import { all, call, fork, put, takeLatest } from 'redux-saga/effects';
import { forceLoginIfExpired } from '../Utils/RedirectionUtils';
import { getSessionSurveys } from '../../Apis/ReportingReadApi';

export function* getSessionSurveyWatcher() {
  yield takeLatest(Actions.GET_SESSION_SURVEY_REQUEST, getSessionSurveyWorker);
}

export function* getSessionSurveyWorker({ payload }) {
  const { sessionKey, webinarKey } = payload;
  let surveys = [];
  try {
    const axiosResponse = yield call(getSessionSurveys, webinarKey, sessionKey);
    surveys = axiosResponse.data;
  } catch (error) {
    yield put({ type: Actions.GET_SESSION_SURVEY_FAILURE, error });
    forceLoginIfExpired(error);
    return;
  }
  yield put({
    type: Actions.GET_SESSION_SURVEY_SUCCESS,
    payload: { surveys }
  });
}

export default function* rootSaga() {
  yield all([fork(getSessionSurveyWatcher)]);
}



// WEBPACK FOOTER //
// ./src/Reducks/SessionSurvey/SessionSurveySagas.js